/**
 * Resolve authoritative server timestamp from API payloads.
 * Never use client wall-clock for delta sync anchors.
 */
export function resolveServerTimeFromPayload(payload) {
   if (!payload || typeof payload !== "object") return "";
   const candidates = [
      payload.serverTime,
      payload.server_time,
      payload.syncedAt,
      payload.synced_at,
      payload.appliedAt,
      payload.applied_at,
      payload.now,
      payload.timestamp,
      payload.meta?.serverTime,
      payload.meta?.syncedAt,
   ];
   for (const value of candidates) {
      const text = String(value || "").trim();
      if (!text) continue;
      const ms = new Date(text).getTime();
      if (Number.isFinite(ms) && ms > 0) return new Date(ms).toISOString();
   }
   return "";
}
